import * as React from 'react'
import { Flex, Heading, Paragraph } from '@dooer/react-ui-kit'
import { FormattedMessage } from 'react-intl'
import messages from './messages'
import styles from './styles'
import CheckIcon from '../icon'

const Success = () => (
  <Flex alignItems="center" flexDirection="column" justifyContent="center" style={styles.root}>
    <CheckIcon />
    <Heading>
      <FormattedMessage {...messages.heading} />
    </Heading>
    <Paragraph>
      <FormattedMessage {...messages.lede} />
    </Paragraph>
  </Flex>
)

export default Success
